package com.siriusxm.pia.views.unifiedaggregator.management

import androidx.compose.runtime.*
import com.siriusxm.pia.components.DialogOverlayAttributes
import com.siriusxm.pia.components.simpleCheckBox
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Text

/**
 * Settings for controlling the visibility of disabled producers/consumers in list views.
 *
 * @param showDisabled When true, disabled producers/consumers are shown in the list.
 *                     When false (default), only enabled items are shown.
 */
data class ProducerConsumerSettings(
    val showDisabled: Boolean = false
)

/**
 * A settings dialog for configuring the producer/consumer list view settings.
 * This dialog allows users to toggle visibility of disabled items.
 *
 * @param settings The current settings state
 * @param entityType A human-readable name for the entity type ("producers" or "consumers")
 * @param onSaveSettings Callback invoked when settings are saved
 */
@Composable
fun DialogOverlayAttributes.producerConsumerSettingsDialog(
    settings: ProducerConsumerSettings,
    entityType: String,
    onSaveSettings: (ProducerConsumerSettings) -> Unit
) {
    var showDisabled by remember(settings) { mutableStateOf(settings.showDisabled) }

    title = "${entityType.replaceFirstChar { it.uppercase() }} View Settings"
    save {
        onSaveSettings(ProducerConsumerSettings(showDisabled = showDisabled))
    }
    content {
        Div({
            style {
                padding(20.px)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
                gap(10.px)
            }
        }) {
            H3({
                style { marginTop(0.px) }
            }) {
                Text("Display Options")
            }
            Div {
                simpleCheckBox("Show disabled $entityType", showDisabled) {
                    showDisabled = it
                }
            }
        }
    }
}
